export { default } from './ChatBubbleContainer';
